<template>
    <div v-if="banner" :class="bannerClasses" class="relative">
        <div class="max-w-screen-xl mx-auto py-2 px-3 sm:px-6 lg:px-8">
            <div class="flex items-center justify-center flex-wrap">
                <div class="flex items-center">
                    <span class="flex p-2 rounded-lg" :class="iconBgClass">
                        <svg v-if="banner.type === 'info'" class="h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
                        </svg>
                        <svg v-else-if="banner.type === 'warning'" class="h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
                        </svg>
                        <svg v-else class="h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                        </svg>
                    </span>
                    <p class="ml-3 font-medium text-white truncate">
                        {{ banner.message }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';

const page = usePage();
const banner = computed(() => page.props.globalBanner);

const bannerClasses = computed(() => {
    if (!banner.value) return '';
    return {
        'bg-blue-600': banner.value.type === 'info',
        'bg-yellow-500': banner.value.type === 'warning',
        'bg-red-600': banner.value.type === 'danger',
    };
});

const iconBgClass = computed(() => {
    if (!banner.value) return '';
    return {
        'bg-blue-700': banner.value.type === 'info',
        'bg-yellow-600': banner.value.type === 'warning',
        'bg-red-700': banner.value.type === 'danger',
    };
});
</script>